
jQuery(document).ready(function ($) {
  	    var current_url = window.location.pathname;
      $('.also-cat > a').each(function(){
        var link_href = $(this).attr("href");
        if(current_url == link_href) {
          $(this).parent().addClass("current");
          $(this).attr("aria-current","page");
        }
      });
    
     $('.sub-cat > a').each(function(){
       var link_href = $(this).attr("href");
       if(current_url == link_href) {
         $(this).parent().addClass("current");
       }
      });

      var also_div = document.querySelector('.also-see-cats');
      if (also_div.offsetHeight < also_div.scrollHeight ||
        also_div.offsetWidth < also_div.scrollWidth) {
        $('#expand-also-see').show();
        } 

    
$('#expand-also-see').click(function() {
  $('.also-see-cats').toggleClass('show-all-cats');
  $('#expand-also-see > a').toggleClass('expanded');
  if($('#expand-also-see > a').hasClass('expanded')) {
    $('#expand-also-see > a').html('Show Less');
    $('#expand-also-see > a').attr('aria-expanded','true');
  } else {
    $('#expand-also-see > a').html('Show More');
    $('#expand-also-see > a').attr('aria-expanded','false');
  }

$(".also-see-cats").find(".also-cat").each(function(){

      $(this).find('a').attr('tabindex', "");

});

  
});




var h = $(".also-see-cats").width();

$(".also-see-cats").find(".also-cat").each(function(){
    if ($(this).position().left + 15 > h) {
      $(this).find('a').attr('tabindex', "-1");
    }    
});



      $("#toggle-cat-trigger").click(function(e){
          e.preventDefault();
          $("#toggle-cat-trigger").toggleClass('expanded');
          $('.also-see-container').slideToggle();
      });

});